import { Injectable } from '@angular/core';
import { EncryptionService } from '@shared';
import { AccountStateService } from 'src/pages/account';

@Injectable()
export class RegistrationStateService extends AccountStateService {
	public constructor(public encryptionService: EncryptionService) {
		super(encryptionService);
	}

	public setPassword(value: string): void {
		this.formValues.password = this.encryptionService.encrypt(value);
	}
}
